/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ACHPaymentDetails,
  ACHPaymentDetails$inboundSchema,
  ACHPaymentDetails$Outbound,
  ACHPaymentDetails$outboundSchema,
} from "./achpaymentdetails.js";
import {
  CardPaymentDetails,
  CardPaymentDetails$inboundSchema,
  CardPaymentDetails$Outbound,
  CardPaymentDetails$outboundSchema,
} from "./cardpaymentdetails.js";
import {
  CollectionPaymentMethodType,
  CollectionPaymentMethodType$inboundSchema,
  CollectionPaymentMethodType$outboundSchema,
} from "./collectionpaymentmethodtype.js";

/**
 * Options for payment links used to collect payment.
 */
export type PaymentLinkPaymentDetailsUpdate = {
  /**
   * A list of payment methods that should be supported for this payment link.
   */
  allowedMethods?: Array<CollectionPaymentMethodType> | undefined;
  /**
   * Options for payment links used to collect a card payment.
   */
  cardDetails?: CardPaymentDetails | undefined;
  /**
   * Options for payment links used to collect an ACH payment.
   */
  achDetails?: ACHPaymentDetails | undefined;
  /**
   * Optional free-form metadata for the transfer.
   */
  metadata?: { [k: string]: string } | undefined;
};

/** @internal */
export const PaymentLinkPaymentDetailsUpdate$inboundSchema: z.ZodType<
  PaymentLinkPaymentDetailsUpdate,
  z.ZodTypeDef,
  unknown
> = z.object({
  allowedMethods: z.array(CollectionPaymentMethodType$inboundSchema).optional(),
  cardDetails: CardPaymentDetails$inboundSchema.optional(),
  achDetails: ACHPaymentDetails$inboundSchema.optional(),
  metadata: z.record(z.string()).optional(),
});
/** @internal */
export type PaymentLinkPaymentDetailsUpdate$Outbound = {
  allowedMethods?: Array<string> | undefined;
  cardDetails?: CardPaymentDetails$Outbound | undefined;
  achDetails?: ACHPaymentDetails$Outbound | undefined;
  metadata?: { [k: string]: string } | undefined;
};

/** @internal */
export const PaymentLinkPaymentDetailsUpdate$outboundSchema: z.ZodType<
  PaymentLinkPaymentDetailsUpdate$Outbound,
  z.ZodTypeDef,
  PaymentLinkPaymentDetailsUpdate
> = z.object({
  allowedMethods: z.array(CollectionPaymentMethodType$outboundSchema)
    .optional(),
  cardDetails: CardPaymentDetails$outboundSchema.optional(),
  achDetails: ACHPaymentDetails$outboundSchema.optional(),
  metadata: z.record(z.string()).optional(),
});

export function paymentLinkPaymentDetailsUpdateToJSON(
  paymentLinkPaymentDetailsUpdate: PaymentLinkPaymentDetailsUpdate,
): string {
  return JSON.stringify(
    PaymentLinkPaymentDetailsUpdate$outboundSchema.parse(
      paymentLinkPaymentDetailsUpdate,
    ),
  );
}
export function paymentLinkPaymentDetailsUpdateFromJSON(
  jsonString: string,
): SafeParseResult<PaymentLinkPaymentDetailsUpdate, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => PaymentLinkPaymentDetailsUpdate$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'PaymentLinkPaymentDetailsUpdate' from JSON`,
  );
}
